import React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useLocalization } from '@im/react-localization';
import Typography from '@mui/material/Typography';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';

type Prop = {
  ShowCentralStockTtypeSku: boolean;
  centralStock: number;
  displayBothFlag?: boolean;
  displayCentralFlag?: boolean;
  displayLocalFlag?: boolean;
  displayOutOfStockFlag: boolean;
  localStock: number;
  onOrder: number;
  productType?: string;
};

export default function WarehouseStockOverMouse(props: Prop) {
  const { translate } = useLocalization();
  return (
    <>
      {props.displayBothFlag ||
      props.displayCentralFlag ||
      props.displayLocalFlag ? (
        <Stack direction="row">
          <Box
            component="span"
            sx={{
              '&::before': {
                backgroundColor: '#E5F4FF',
                color: '#333333',
                content: '""',
                display: 'block',
                height: 12,
                left: 'calc(10% - 6px)',
                position: 'absolute',
                top: -8,
                transform: 'rotate(45deg)',
                width: 12,
                zIndex: '999',
              },
              alignItems: 'flex-start',
              background: '#E5F4FF',
              borderRadius: '6px',
              lineHeight: '19px',
              marginTop: '8px',
              padding: '12px',
              position: 'relative',
            }}
          >
            <Typography
              sx={{
                backgroundColor: '#E5F4FF',
                fontSize: '0.875rem',
                listStyle: 'none',
                p: 2,
              }}
            >
              {props.displayBothFlag &&
                props.productType === null &&
                props.ShowCentralStockTtypeSku && (
                  <List dense disablePadding>
                    <StyledListItem>
                      <ListItemText>
                        <Typography
                          component="span"
                          sx={{ fontWeight: 'bold' }}
                        >
                          {props.localStock} &nbsp;
                          {translate('Warehouse.LocalOnlyInStockText')} &nbsp;
                        </Typography>
                      </ListItemText>
                      <ListItemText>
                        <Typography component="span">
                          {translate('Warehouse.LocalOnlyInStockText2')}
                        </Typography>
                      </ListItemText>
                    </StyledListItem>
                  </List>
                )}

              {props.displayBothFlag &&
                props.ShowCentralStockTtypeSku &&
                props.productType !== null &&
                (props.productType?.toUpperCase() === 'T' ||
                  props.productType?.toUpperCase() === 'W') && (
                  <List dense disablePadding>
                    <StyledListItem>
                      <ListItemText>
                        <Typography
                          component="span"
                          sx={{ fontWeight: 'bold' }}
                        >
                          {props.productType?.toUpperCase() === 'T' ? (
                            <>
                              {props.centralStock}&nbsp;
                              {translate(
                                'Warehouse.CentralOnlyInStockTextTtype'
                              )}
                            </>
                          ) : (
                            <>
                              {props.centralStock}&nbsp;
                              {translate('Warehouse.CentralOnlyInStockText')}
                            </>
                          )}
                        </Typography>
                      </ListItemText>
                    </StyledListItem>
                  </List>
                )}

              {props.displayBothFlag && !props.ShowCentralStockTtypeSku && (
                <>
                  <List dense disablePadding>
                    <StyledListItem>
                      <ListItemText>
                        <Typography
                          component="span"
                          sx={{ fontWeight: 'bold' }}
                        >
                          {props.localStock} &nbsp;
                          {translate('Warehouse.LocalOnlyInStockText')} &nbsp;
                        </Typography>
                      </ListItemText>
                      <ListItemText>
                        <Typography component="span">
                          {translate('Warehouse.LocalOnlyInStockText2')}
                        </Typography>
                      </ListItemText>
                    </StyledListItem>
                    <StyledListItem>
                      <ListItemText>
                        <Typography
                          component="span"
                          sx={{ fontWeight: 'bold' }}
                        >
                          {props.productType?.toUpperCase() === 'T' ? (
                            <>
                              {props.centralStock}&nbsp;
                              {translate(
                                'Warehouse.CentralOnlyInStockTextTtype'
                              )}
                            </>
                          ) : (
                            <>
                              {props.centralStock}&nbsp;
                              {translate('Warehouse.CentralOnlyInStockText')}
                            </>
                          )}
                        </Typography>
                      </ListItemText>
                    </StyledListItem>
                  </List>
                </>
              )}

              {props.displayCentralFlag && (
                <>
                  <List dense disablePadding>
                    <StyledListItem>
                      <ListItemText>
                        <Typography component="span">
                          {props.productType?.toUpperCase() === 'T' ? (
                            <>
                              {props.centralStock} &nbsp;
                              {translate(
                                'Warehouse.CentralOnlyInStockTextTtype'
                              )}
                            </>
                          ) : (
                            <>
                              {props.centralStock} &nbsp;
                              {translate('Warehouse.CentralOnlyInStockText')}
                            </>
                          )}
                        </Typography>
                      </ListItemText>
                    </StyledListItem>
                  </List>
                </>
              )}

              {props.displayLocalFlag && (
                <>
                  <List dense disablePadding>
                    <StyledListItem>
                      <ListItemText>
                        <Typography component="span">
                          {props.localStock} &nbsp;
                          {translate('Warehouse.LocalOnlyInStockText')}&nbsp;
                          {translate('Warehouse.LocalOnlyInStockText2')}
                        </Typography>
                      </ListItemText>
                    </StyledListItem>
                  </List>
                </>
              )}
            </Typography>
          </Box>
        </Stack>
      ) : null}
    </>
  );
}

const StyledListItem = styled(ListItem)({
  '&.MuiListItemText-root': {
    margin: '0',
    padding: '0',
  },
  '&:before': {
    color: '#000000',
    content: '"●"',
    paddingRight: '8px',
  },
});
